/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/vertreter-add-to-warenkorb/shop.dialogs.vertreter-add-to-warenkorb.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {Warenkorb} from '../../../../models/warenkorb';
import {AppViewService} from '../../../../services/app.view.service';
import {AppShopService} from '../../../../services/app.shop.service';

/**
 * Zweck: Beschreibt class ShopDialogsVertreterAddToWarenkorbComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.vertreter-add-to-warenkorb.component.html',
    styleUrls: ['shop.dialogs.vertreter-add-to-warenkorb.component.scss'],
    standalone: false
})
export class ShopDialogsVertreterAddToWarenkorbComponent {

  wk: Warenkorb;
  entry: WarenkorbEntry;

  disableDialog = false;
  disabled = false;

  vertreterconfig: any;


/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<ShopDialogsVertreterAddToWarenkorbComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              public wksvc: AppWarenkorbService, public vsvc: AppViewService, private ssvc: AppShopService) {
    this.entry = data;
    this.wk = wksvc.primary_warenkorb.value;
    this.vertreterconfig = vsvc.$vertreterconfig;
  }

/**
 * Beschreibt Methode change und ihren Rückgabevertrag.
 */
  change() {
  }

/**
 * Beschreibt Methode add und ihren Rückgabevertrag.
 */
  add() {
    this.ssvc.addToWarenkorb(this.wk, this.entry, () => {
      this.close();
    });
  }

/**
 * Beschreibt Methode close und ihren Rückgabevertrag.
 */
  close() {
    this.dialogRef.close();
  }

}
